import { createAsyncThunk } from "@reduxjs/toolkit"

import { claimGuestWithGoogle, guestLogin } from "src/store/user"
import { loadUserData } from "src/store/auth/loadUserData"

/* Play as a guest (owner, 2026-10-02): `login.js` with the first half swapped, like the Google and
   register doors — get tokens, then load who you are. */
export const playAsGuest = createAsyncThunk("auth/playAsGuest", async (_, { dispatch, rejectWithValue }) => {
  try {
    await dispatch(guestLogin()).unwrap()
    await dispatch(loadUserData())
    return
  } catch (error) {
    return rejectWithValue(error)
  }
})

/* A guest saves the account with Google. When that Google account already opened an account here,
   the session now belongs to that one: what the guest had loaded (its lobby, its games, its wallet)
   is put down before the other account's is loaded, the way signing out puts it down. Resolves to
   `{switched}` so the caller can say which happened. */
export const saveGuestWithGoogle = createAsyncThunk(
  "auth/saveGuestWithGoogle",
  async (credential, { dispatch, rejectWithValue }) => {
    try {
      const { switched } = await dispatch(claimGuestWithGoogle(credential)).unwrap()
      if (switched) {
        dispatch({ type: "lobby/reset" })
        dispatch({ type: "game/reset" })
        dispatch({ type: "economy/reset" })
      }
      await dispatch(loadUserData())
      return { switched }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
